class HbsVeznePoscihaztanimDTO {
    id?: number = null;
    fkOrganizasyon?: number = null;
    adi?: string = "";
    ipadres?: string = "";
    username?: string = "";
    password?: string = "";
    fkPoscihaztip?: number = null;
    eklemeKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;

    //Arama Kriterleri
    multiOrganizasyon?: string = null;
}
export default HbsVeznePoscihaztanimDTO;